import MaterialTable, { MTable, MTableBodyRow } from 'material-table';
import React, { useMemo } from 'react';
import { localization } from '../../../helpers/table';
import { tableIcons } from '../../../helpers';
import TooltippedElement from '../../common/TooltippedElement';
import { monthsArray } from '../../../stores/StratProject/StrategyStore';
import './ProjectImpactTable.less'
import { id } from 'date-fns/locale';
import { useParams } from 'react-router-dom';

export default function ProjectImpactTable({results, trls}){
  const {stratId} = useParams();
  const treeData = useMemo(() => results.map((value) => ({...value, tableData: {isTreeExpanded: true}})), [results])
  
  return (
    <div className='projectImpact'>
      <h2 className='mb-2' style={{textAlign: 'left', fontSize: 20 }}>Проект влияет на достижения выдающихся результатов СП{stratId} </h2>
      <MaterialTable
        data={treeData}
        columns={[
          {
            title: 'Результат/Веха',
            field: 'name',
            sorting: false,
            cellStyle: {
              borderBottom: '1px solid #d4d4d4',
              minWidth: window.innerWidth * 0.5,
              fontSize: 16,
            },
            render: (rowData) => <div>
              {rowData.parentId && rowData.num === 1 && <p style={{fontWeight: 600, marginBottom: 6, color: '#636A73'}}>В том числе вехи:</p>}
              <p style={{paddingLeft: rowData.parentId ? 16 : 0}}>{rowData.parentId ? `${treeData.find((parent) => parent.id === rowData.parentId).num}.${rowData.num}` : `${rowData.num}.`} {rowData.name}</p>
            </div>
          },
          {
            title: 'Дата вып. (план)',
            field: 'datePlan',
            cellStyle: {
              borderBottom: '1px solid #d4d4d4',
              fontSize: 16,
            },
            render: rowData => rowData.monthPlan ? `${monthsArray[rowData.monthPlan]}, ${rowData.yearPlan}` : '-',
            customSort: (row1, row2) => {
              return row1.parentId && row2.parentId ? 0 :  row1.yearPlan - row2.yearPlan || row1.monthPlan - row2.monthPlan
            }
          },
          {
            title: 'УГТ (план)',
            field: 'trlId',
            sorting: false,
            cellStyle: {
              borderBottom: '1px solid #d4d4d4',
              fontSize: 16,
            },
            render: rowData => rowData.trlId && trls ?
          <TooltippedElement 
            iconSize={'16px'}
						tooltip={
							trls.find(trl => trl.id === rowData.trlId)?.descr
						}>
             {rowData.trlId}   
          </TooltippedElement> : 
          '-'
          }
        ]}
        options={{
          ...options, 
          rowStyle: (rowData) => ({backgroundColor: !rowData.parentId ? '#F2F2F2' : '#fff'})
        }}
        localization={localization}
        icons={tableIcons}
        parentChildData={(row, rows) => rows.find((parent) => parent.id === row.parentId)}
    />
    </div>
    
  )
}

const options = {
  filtering: false,
  paging: false,
  search: false,
  draggable: false,
  toolbar: false,
  headerStyle: {
    height: 50,
    color: '#7F7F7F',
    borderBottom: '1px solid #D4D4D4',
    fontSize: 16,
  },
  rowStyle: {
    fontSize: 16
  }
}